<template>
    <div class="ai-ask">
        <nav-list :clickIndex="clickIndex"></nav-list>
        <div class="header-ai">
            <img src="https://xzcs-public-files.oss-cn-beijing.aliyuncs.com/static/screen/ai-ask-logo.png" alt="" class="ai-logo">
        </div>
        <div>
            <vue-seamless-scroll
                :data="dataList"
                :class-option="optionHover"
                class="seamless-warp"
            >
                <ul class="item">
                    <li v-for="(item, index) in dataList" :key="index" >
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <div class="grid-content username">
                                    <img src="../../assets/img/username-icon.png" alt="" style="width: 51px; height: 35px">
                                    <span style="margin-left: 10px">{{item.city}}用户/{{ item.username }}</span>
                                </div>
                            </el-col>

                            <el-col :span="6">
                                <div class="grid-content add_timetext">
                                    <div style="height: 35px"></div>
                                   <span> {{ item.add_timetext }} </span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="grid-content content">
                                    <div style="height: 35px"></div>
                                    <span style=" white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;">提问了：{{ item.content }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>
    </div>
</template>

<script>

import navList from "@/components/navList/navList.vue";
import {aiAskList} from "@/api/homeIndex/homeIndex"
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
    name: 'aiAsk',
    components: {
        vueSeamlessScroll,
        navList
    },
    data() {
        return {
            clickIndex: 8,
            dataList: []
        }
    },

    computed: {
        optionHover() {
            return {
                hoverStop: false,
                // singleHeight: 44,
                // waitTime: 800,
                step: 0.5
            };
        },
    },

    created() {

    },

    mounted() {
        this.getList()
        this.getWebSocket()
    },

    methods: {
        getList() {
            aiAskList().then(res => {
                console.log(res)
                let arr = []
                arr =  res.data.data.filter(val => {
                    return val.content != '' && val.city != ''
                })
                this.dataList = arr
            })
        },

        getWebSocket() {
            this.$goeasy.connect({
                onSuccess: function () {
                    //连接成功
                    console.log("GoEasy connect successfully."); //连接成功
                },
                onFailed: function (error) {
                    //连接失败
                    console.log(
                        "Failed to connect GoEasy, code:" +
                        error.code +
                        ",error:" +
                        error.content
                    );
                },
                onProgress: function (attempts) {
                    //连接或自动重连中
                    console.log("GoEasy is connecting", attempts);
                },
            });
            let pubsub = this.$goeasy.pubsub;
            let _that = this;
            pubsub.subscribe({
                channel: "screen_channel", //替换为您自己的channel
                onMessage: function (message) {
                    console.log("是否能从服务端主动接收到消息");

                },
                onSuccess: function () {
                    console.log("Channel订阅成功。");
                },
                onFailed: function (error) {
                    console.log(
                        "Channel订阅失败, 错误编码：" +
                        error.code +
                        " 错误信息：" +
                        error.content
                    );
                },
            });
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/styles/common.scss";
@import "@/styles/aiAsk.scss";
</style>